<template>
    <div v-cloak>
        <div
            v-if="isLoading"
            class="alert alert-warning"
            role="alert"
        >
            {{ $t('loading') }}...
        </div>

        <div
            v-if="((isLoading === false) && ! rows.length)"
            class="alert alert-danger"
            role="alert"
        >
            {{ $t('lessonEmpty') }}
        </div>

        <div class="list-group">
            <div
                v-if="((isLoading === false) && rows.length)"
                class="card mb-4 no-break d-print-none"
            >
                <h5 class="card-header">
                    {{ $t('jumpTo') }}...
                </h5>
                <div class="card-body">
                    <ul>
                        <li
                            v-for="component in rows"
                            :key="component.id"
                        >
                            <a :href="`#component-${component.id}`">
                                <span v-if="(component.translations && component.translations.length)">{{ component.translations[0].title }}</span>
                                <span v-else>{{ component.title }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <template
                v-for="row in rows"
                :key="row.id"
            >
                <series-outline
                    v-if="(showSeriesOutline && row.type && (row.type.slug === 'series-aims'))"
                    :series-id="Number(seriesId)"
                    :language-id="Number(languageId)"
                    :lesson-id="Number(lessonId)"
                />

                <component-item
                    :component="row"
                    :language-id="Number(languageId)"
                />
            </template>

            <div
                v-for="row in rows"
                :key="row.id"
                class="d-none d-print-block"
            >
                <component-item-printable
                    :component="row"
                    :language-id="Number(languageId)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import SeriesOutline from './SeriesOutline.vue';
import ComponentItem from './ComponentItem.vue';
import ComponentItemPrintable from "./ComponentItemPrintable.vue";

// toast config
const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 5000,
});

export default {
    components: {
        ComponentItemPrintable,
        SeriesOutline,
        ComponentItem,
    },

    props: {
        type: {
            type: String,
            default: '',
        },
        lessonId: {
            type: Number,
            default: null,
        },
        seriesId: {
            type: Number,
            required: true,
        },
        languageId: {
            type: [Number, String],
            default: null,
        },
        showSeriesOutline: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isLoading: null,
            rows: [],
        };
    },

    watch: {
        lessonId: function () {
            this.getRows();
        },
        languageId: function () {
            this.getRows();
        },
    },

    mounted: function () {
        if(this.lessonId) {
            this.getRows();
        }

        var self = this;

        // listen for 'Ctrl+C' or 'Print Screen'
        document.body.addEventListener('keydown', (e) => {
            e = e || window.event;

            let key = e.which || e.keyCode; // "keyCode" detection
            let ctrl = e.ctrlKey || e.metaKey; // "ctrl" detection

            if (((key === 67) && ctrl) || (key === 36)) {
                self.warnUser();
            }
        });

        document.addEventListener('copy', (e) => {
            self.warnUser();
        });
    },

    methods: {
        getRows: function () {
            this.isLoading = true;
            this.rows = [];

            axios({
                method: 'get',
                url: `/subscriber/api/lessons/${this.lessonId}/components/`,
                params: {
                    language_id: this.languageId,
                    type: this.type,
                },

            })
            .then((response) => {
                this.rows = response.data;
                this.isLoading = false;
            });
        },

        warnUser: function () {
            Toast.fire({
                type: 'info',
                title: this.$t('shareWarning'),
            });
        },
    },
};
</script>
